
import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from "sweetalert2";

import AuthContext from '../context/auth-context';

import { MdArrowForward } from "react-icons/md";

import Card from '../components/UI/Card';

// HOOKS
import useInput from '../hooks/useInput';
import useGetProgramas from '../hooks/useGetProgramas';

// ASSETS
import logo from '../assets/logoufm1.png';
import ReCAPTCHA from 'react-google-recaptcha';
// import picture1 from '../assets/Picture1.jpg';
// import picture2 from '../assets/Picture2.jpg';
// import picture3 from '../assets/Picture3.jpg';
// import picture4 from '../assets/Picture4.jpg';
import classes from './Register.module.css';


const Register = () => {

    const navigate = useNavigate();
    const authContext = useContext(AuthContext);
    const [recaptcha, setRecaptcha] = useState(false);

    const carreras = useGetProgramas();

    //INPUT PRIMER NOMBRE
    const primerNombreValidacion = value => value.trim() !== "";
    const {
        value: primerNombre,
        isValid: primerNombreIsValid,
        isTouched: primerNombreIsTouched,
        divInput: divNombres,
        valueChangeHandler: primerNombreChangeHanlder,
        inputBlurHandler: primerNombreBlurHandler,
        resetInput: resetInputPrimerNombre,
        scrollToDiv: scrollToDivNombres
    } = useInput(primerNombreValidacion);

    //INPUT SEGUNDO NOMBRE
    const segundoNombreValidacion = value => true;
    const {
        value: segundoNombre,
        isValid: segundoNombreIsValid,
        isTouched: segundoNombreIsTouched,
        valueChangeHandler: segundoNombreChangeHanlder,
        inputBlurHandler: segundoNombreBlurHandler,
        resetInput: resetInputSegundoNombre
    } = useInput(segundoNombreValidacion);

    //INPUT PRIMER APELLIDO
    const primerApellidoValidacion = value => value.trim() !== "";
    const {
        value: primerApellido,
        isValid: primerApellidoIsValid,
        isTouched: primerApellidoIsTouched,
        divInput: divApellidos,
        valueChangeHandler: primerApellidoChangeHanlder,
        inputBlurHandler: primerApellidoBlurHandler,
        resetInput: resetInputPrimerApellido,
        scrollToDiv: scrollToDivApellidos
    } = useInput(primerApellidoValidacion);

    //INPUT SEGUNDO APELLIDO
    const segundoApellidoValidacion = value => true;
    const {
        value: segundoApellido,
        isValid: segundoApellidoIsValid,
        isTouched: segundoApellidoIsTouched,
        valueChangeHandler:segundoApellidoChangeHanlder,
        inputBlurHandler: segundoApellidoBlurHandler,
        resetInput: resetInputSegundoApellido,
    } = useInput(segundoApellidoValidacion);

    // INPUT EMAIL
    const emailValidacion = value => {
        const emailRE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRE.test(value);
    };
    const {
        value: email,
        isValid: emailIsValid,
        isTouched: emailIsTouched,
        divInput: divEmail,
        valueChangeHandler: emailChangeHanlder,
        inputBlurHandler: emailBlurHandler,
        resetInput: resetInputEmail,
        scrollToDiv: scrollToDivEmail
    } = useInput(emailValidacion);

    // INPUT PASSWORD
    const passwordValidacion = value => value.trim() !== "" && value.length >= 6;
    const {
        value: password,
        isValid: passwordIsValid,
        isTouched: passwordIsTouched,
        divInput: divPassword,
        valueChangeHandler: passwordChangeHanlder,
        inputBlurHandler: passwordBlurHandler,
        resetInput: resetInputPassword,
        scrollToDiv: scrollToDivPassword
    } = useInput(passwordValidacion);

    // INPUT CONFIRMACION PASSWORD
    const confirmacionPasswordValidacion = value => value.trim() !== "" && value.length > 3;
    const {
        value: confirmacionPassword,
        isValid: confirmacionPasswordIsValid,
        isTouched: confirmacionPasswordIsTouched,
        divInput: divConfirmacionPassword,
        valueChangeHandler: confirmacionPasswordChangeHanlder,
        inputBlurHandler: confirmacionPasswordBlurHandler,
        resetInput: resetInputConfirmacionPassword,
        scrollToDiv: scrollToDivConfirmacionPassword
    } = useInput(confirmacionPasswordValidacion);

    // INPUT PROGRAMA
    const programaValidacion = value => value.trim() !== "";
    const {
        value: programa,
        isValid: programaIsValid,
        isTouched: programaIsTouched,
        divInput: divPrograma,
        valueChangeHandler: programaChangeHanlder,
        inputBlurHandler: programaBlurHandler,
        resetInput: resetInputPrograma,
        scrollToDiv: scrollToDivPrograma
    } = useInput(programaValidacion);

    let formIsValid = false;
    let passwordsMatch = password === confirmacionPassword;
    let passwordErrorMessage = "Debe ingresar una contraseña válida";

    passwordErrorMessage = confirmacionPasswordIsTouched && !passwordsMatch ? "Las contraseñas deben coincidir" : passwordErrorMessage


    if( primerNombreIsValid &&
        segundoNombreIsValid &&
        primerApellidoIsValid &&
        segundoApellidoIsValid &&
        emailIsValid && 
        passwordIsValid &&
        confirmacionPasswordIsValid &&
        passwordsMatch &&
        programaIsValid ){
        formIsValid = true;
    }

    const formSubmitHandler = async (event) => {
        event.preventDefault();

        // Validacion visual inputs
        primerNombreBlurHandler();
        segundoNombreBlurHandler();
        primerApellidoBlurHandler();
        segundoApellidoBlurHandler();
        emailBlurHandler();
        passwordBlurHandler();
        confirmacionPasswordBlurHandler();
        programaBlurHandler();

        // ReCAPTCHA valido
        if(!recaptcha)
            return;
        
        // Form invalido 
        if(!formIsValid){

            if(!primerNombreIsValid || !segundoNombreIsValid){
                scrollToDivNombres();
                return;
            }

            if(!primerApellidoIsValid || !segundoApellidoIsValid){
                scrollToDivApellidos();
                return;
            }

            if(!emailIsValid){
                scrollToDivEmail();
                return;
            }

            if(!passwordIsValid){
                scrollToDivPassword();
                return;
            }

            if(!confirmacionPasswordIsValid || !passwordsMatch){
                scrollToDivConfirmacionPassword();
                return;
            }

            if(!programaIsValid){
                scrollToDivPrograma();
                return;
            }

        };


        let formData = new FormData();
        formData.append('primerNombre', primerNombre);
        formData.append('segundoNombre', segundoNombre);
        formData.append('primerApellido', primerApellido);
        formData.append('segundoApellido', segundoApellido);
        formData.append('userEmail', email);
        formData.append('userPassword', password);
        formData.append('programa', programa);
        formData.append('registroNuevoUsuario', 1);

        console.log(formData);

        const response = await axios.post(process.env.REACT_APP_API_URL, formData);
        
        const result = response.data;

        if( result.STATUS && result.STATUS === "SUCCESS" && result.MESSAGE && result.TOKEN_ID ){

            // LOGIN DE USUARIO
            const expiresIn = 3600; // segundos
            const expirationTime = new Date(new Date().getTime() + (expiresIn * 1000));
            authContext.login(result.TOKEN_ID, expirationTime.toISOString());

            Swal.fire({
                icon: 'success',
                title: result.MESSAGE,
                showConfirmButton: false,
                timer: 5000
            });
            navigate('/', { replace: true });

        } else if( result.STATUS && result.STATUS === "ERROR" && result.ERRORS && result.ERRORS.length > 0 ){
            
            let strErrors = "";
            result.ERRORS.forEach(
                (error) => {
                    strErrors += error.MESSAGE+"<br><br>";
        
                    if( error.ID === 'invalid-nombres' ){
                        resetInputPrimerNombre();
                        resetInputSegundoNombre();
                        primerNombreBlurHandler();
                        segundoNombreBlurHandler();
                    } else if( error.ID === 'invalid-apellidos' ){
                        resetInputPrimerApellido();
                        resetInputSegundoApellido();
                        primerApellidoBlurHandler();
                        segundoApellidoBlurHandler();
                    } else if( error.ID === 'invalid-email' || error.ID === 'email-exists' ){
                        resetInputEmail();
                        emailBlurHandler();
                    } else if( error.ID === 'invalid-password' ){
                        resetInputPassword();
                        resetInputConfirmacionPassword();
                        passwordBlurHandler();
                        confirmacionPasswordBlurHandler();
                    } else if( error.ID === 'invalid-programa' ){
                        resetInputPrograma();
                        programaBlurHandler();
                    }
                }
            );

            Swal.fire({
                icon: 'error',
                titleText: "¡Error!",
                html: `
                    <div class='row w-100 mx-0'>
                        <div class='col-sm-8 mx-auto'>
                            <div class='text-danger text-center lead'>
                                ${strErrors}
                            </div>
                        </div>
                    </div>
                `,
                showConfirmButton: false,
                showDenyButton: true,
                denyButtonText: "Aceptar",
                backdrop: true,
                allowOutsideClick: false
            });

        } else if( result.STATUS && result.STATUS === "ERROR" && result.ERROR && result.ERROR.ID && result.ERROR.MESSAGE ) {
            Swal.fire({
                icon: 'error',
                titleText: "¡Error!",
                text: result.ERROR.MESSAGE,
                showConfirmButton: false,
                showDenyButton: true,
                denyButtonText: "Aceptar",
                backdrop: true,
                allowOutsideClick: false
            });
        } else {
            Swal.fire({
                icon: 'error',
                titleText: "¡Error!",
                text: "Ocurrió un error desconocido. Inténtelo de nuevo más tarde.",
                showConfirmButton: false,
                showDenyButton: true,
                denyButtonText: "Aceptar",
                backdrop: true,
                allowOutsideClick: false
            });
        }

    };

    const onReCAPTCHAChange = value => setRecaptcha(value);

    return (
        <div className="row">
            <div className="offset-md-3 col-md-6">
                <Card>
                    
                    <form className="row my-4" onSubmit={formSubmitHandler}>

                        {/* LOGO */}
                        <div className="col-md-12 text-center my-3">
                            <img src={logo} alt="logo-ufm" style={{height: '5.5rem'}} />
                        </div>

                        {/* LABEL TITULO */}
                        <div className="col-md-8 offset-md-2 mb-1">
                            <h1 className="display-6 mb-0" style={{ color: 'rgba(0,0,0,0.65)', fontSize: '1.5rem' }}>Crear usuario</h1>
                        </div>

                        <div className="col-md-8 offset-md-2"><hr className="mt-0" /></div>


                        {/* NOMBRE(S) */}
                        <div className="col-md-8 offset-md-2 mb-3" ref={divNombres}>
                            <label className="form-label text-black-50" style={{userSelect: "none"}}>Nombre(s)</label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    name="primerNombre"
                                    value={primerNombre}
                                    className={`form-control form-control-sm shadow-sm ${primerNombreIsTouched ? ((primerNombreIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                    placeholder="Primer nombre"
                                    autoComplete='off' 
                                    onChange={primerNombreChangeHanlder}
                                    onBlur={primerNombreBlurHandler} />
                                <input
                                    type="text"
                                    name="segundoNombre"
                                    value={segundoNombre}
                                    className={`form-control form-control-sm shadow-sm ${segundoNombreIsTouched ? ((segundoNombreIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                    placeholder="Segundo nombre"
                                    autoComplete='off'
                                    onChange={segundoNombreChangeHanlder}
                                    onBlur={segundoNombreBlurHandler} />
                                <div className="invalid-feedback">
                                    Campo obligatorio
                                </div>
                            </div>
                        </div>

                        {/* APELLIDO(S) */}
                        <div className="col-md-8 offset-md-2 mb-3" ref={divApellidos}>
                            <label className="form-label text-black-50" style={{userSelect: "none"}}>Apellido(s)</label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    name="primerApellido"
                                    value={primerApellido}
                                    className={`form-control form-control-sm shadow-sm ${primerApellidoIsTouched ? ((primerApellidoIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                    placeholder="Primer apellido"
                                    autoComplete='off'
                                    onChange={primerApellidoChangeHanlder} 
                                    onBlur={primerApellidoBlurHandler} />
                                <input
                                    type="text"
                                    name="segundoApellido"
                                    value={segundoApellido}
                                    className={`form-control form-control-sm shadow-sm ${segundoApellidoIsTouched ? ((segundoApellidoIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                    placeholder="Segundo apellido"
                                    autoComplete='off'
                                    onChange={segundoApellidoChangeHanlder}
                                    onBlur={segundoApellidoBlurHandler} />
                                <div className="invalid-feedback" id="validacion-apellidos">
                                    Campo obligatorio
                                </div>
                            </div>
                        </div>

                        {/* EMAIL */}
                        <div className="col-md-8 offset-md-2 mb-3 mt-1" ref={divEmail}>
                            <label className="form-label text-black-50" style={{userSelect: "none"}}>Correo electrónico</label>
                            <input 
                                type="email" 
                                name="email"
                                className={`form-control form-control-sm shadow-sm ${emailIsTouched ? ((emailIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                value={email}
                                onChange={emailChangeHanlder}
                                onBlur={emailBlurHandler}
                                placeholder="ejemplo@gmail.com" />
                            <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                Debe ingresar un correo electrónico
                            </div>
                        </div>

                        {/* PASSWORD */}
                        <div className="col-md-6 offset-md-2 mb-3" ref={divPassword}>
                            <label className="form-label text-black-50" style={{userSelect: "none"}}>Contraseña</label>
                            <input 
                                type="password"
                                name="password"
                                className={`form-control form-control-sm shadow-sm ${passwordIsTouched ? ((passwordIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                value={password}
                                onChange={passwordChangeHanlder}
                                onBlur={passwordBlurHandler}
                                autoComplete="on" />
                            <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                Debe ingresar una contraseña válida
                            </div>
                            <div className={`form-text ${passwordIsTouched ? ((passwordIsValid) ? 'd-none' : '') : ''}`}>
                                La contraseña debe de tener al menos 6 caracteres.
                            </div>
                        </div>

                        {/* CONFIRMACION PASSWORD */}
                        <div className="col-md-6 offset-md-2 mb-3" ref={divConfirmacionPassword}>
                            <label className="form-label text-black-50" style={{userSelect: "none"}}>Confirmar contraseña</label>
                            <input 
                                type="password" 
                                name="confirmacionPassword"
                                className={`form-control form-control-sm shadow-sm ${confirmacionPasswordIsTouched ? ((confirmacionPasswordIsValid && passwordsMatch) ? 'is-valid' : 'is-invalid') : ''}`}
                                value={confirmacionPassword}
                                onChange={confirmacionPasswordChangeHanlder}
                                onBlur={confirmacionPasswordBlurHandler} 
                                autoComplete="on" />
                            <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                {passwordErrorMessage}
                            </div>
                        </div>

                        {/* LABEL PROGRAMA */}
                        <div className="col-md-8 offset-md-2 mt-4 mb-1">
                            <h1 className="display-6 mb-0" style={{ color: 'rgba(0,0,0,0.65)', fontSize: '1.5rem' }}>Seleccionar programa</h1>
                        </div>

                        <div className="col-md-8 offset-md-2"><hr className="mt-0" /></div>

                        {/* PROGRAMA */}
                        <div className="col-md-8 offset-md-2 mb-3" ref={divPrograma}>
                            <label className="form-label text-black-50" style={{userSelect: "none"}} htmlFor='programa' >Programa</label>
                            <select 
                                className={`form-select form-select-sm shadow-sm ${programaIsTouched ? ((programaIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                name='programa' 
                                value={programa} 
                                onChange={programaChangeHanlder}
                                onBlur={programaBlurHandler}>
                                <option value="default" hidden>{ carreras.length > 0 ? "Seleccionar programa" : "No hay programas para mostrar" }</option>
                                {
                                    carreras.length > 0 &&
                                    carreras.map((carrerasFacultad) => (
                                        <optgroup label={carrerasFacultad[0].NOMBRE_FACULTAD} key={carrerasFacultad[0].ID_FACULTAD}>
                                            {carrerasFacultad.map((carrera) => (
                                                <option value={carrera.ID_CARRERA} key={carrera.ID_CARRERA}>{carrera.NOMBRE_CARRERA}</option>
                                            ))}
                                        </optgroup>
                                    ))
                                }
                            </select>
                            <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                Campo obligatorio
                            </div>
                        </div>
                        
                        <div className="col-md-8 offset-md-2"><hr className="my-4" /></div>

                        <div className="col-md-8 offset-md-2 text-center">
                            <ReCAPTCHA 
                                sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                                onChange={onReCAPTCHAChange}
                                className={classes.reCAPTCHAdiv}
                            />
                        </div>

                        {/* BUTTONS */}
                        <div className="col-md-8 offset-md-2 my-3 text-center">
                            <button
                                className={`btn btn-danger`}
                                disabled={recaptcha && formIsValid ? false:true}
                                >
                                <span style={{display: 'flex'}}>
                                    Crear usuario&nbsp;<MdArrowForward className="my-1" />
                                </span>
                            </button>
                        </div>

                    </form>

                </Card>
            </div>

            <div className="offset-md-3 col-md-6 mt-2">
                <Card style={{ borderRadius: '0.375rem' }} >
                    <div className="col-md-10 offset-md-1 my-3">
                    Volver al <Link to={"/login"} className="link-dark" >inicio de sesión</Link>
                    </div>
                </Card>
            </div>

        </div>
    );
};

export default Register;